import { HTMLAttributes } from 'react';

export enum PlayerControlButtonSize {
    XXL = 'xxl',
    XL = 'xl',
}

export interface PlayerControlButtonProps extends HTMLAttributes<HTMLElement> {
    size?: PlayerControlButtonSize;
}
